import { render, staticRenderFns } from "./EmailSmtpSettingsPage.vue?vue&type=template&id=fdad5b80&scoped=true&lang=pug&"
import script from "./EmailSmtpSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./EmailSmtpSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdad5b80",
  null
  
)

export default component.exports